import { render, staticRenderFns } from "./Epg.vue?vue&type=template&id=7713e837"
import script from "./Epg.vue?vue&type=script&lang=js"
export * from "./Epg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports